const dsAvailability = (($) => {

    function checkAvailability(product, quantity) {
        const quantity_multiplied = (quantity * product.inventory_multiplier) + addFamiliyQuantities(product),
            inventory = calculateInventory('current', product),
            inventory_next = calculateInventory('next', product),
            success = { success: true, message: '' };
        if (maximumShouldChange(product)) {
            product.maximum = product.edit_quantity;
        }
        if (product.maximum > 0 && quantity > product.maximum) {
            product.available = product.maximum;
            return availError(product, quantity);
        }
        if (!product.online && quantity_multiplied > product.inventory_reserved) {
            return availError(product, quantity);
        }
        if (!product.status && quantity_multiplied > product.inventory_reserved) {
            return availError(product, quantity);
        }
        if (product.inventory_override) {
            return success;
        }
        if (!product.run_date.isValid) {
            if (quantity_multiplied > inventory + product.inventory_reserved) {
                return availError(product, quantity);
            }
        } else {
            if (product.date_to.isValid() && product.run_date.isAfter(product.date_to) && quantity_multiplied > product.inventory_reserved) {
                return availError(product, quantity);
            }
            if (product.date_unlimited.isValid() && product.run_date.isSameOrAfter(product.date_unlimited)) {
                return success;
            }
            if (product.date_next.isValid() && product.run_date.isSameOrAfter(product.date_next) && quantity_multiplied > (inventory + inventory_next + product.inventory_reserved)) {
                product.available = inventory + inventory_next;
                return availError(product, quantity);
            }
            if ((!product.date_next.isValid() || product.date_next.isValid() && product.run_date.isBefore(product.date_next)) && quantity_multiplied > (inventory + product.inventory_reserved)) {
                return availError(product, quantity);
            }
        }
        return success;
    }

    function availError(product, quantity) {
        let day = moment(),
            today = day.startOf('day'),
            date_error = false;
        if (maximumShouldChange(product)) {
            product.maximum = product.edit_quantity;
        }
        if (!product.online || !product.status) {
            return availErrorObj('Product unavailable.');
        }
        if (product.maximum > 0 && quantity > product.maximum) {
            return availErrorObj('The maximum quantity that you may order for this product is <strong>' + product.maximum + '</strong>.');
        }
        let message = 'There are no more currently available.<br />'
        if (product.date_next.isValid() && product.date_next.isAfter(product.run_date)) {
            message += 'More availability from <strong>' + product.date_next.format('D/M/YY') + '</strong>.<br />';
            if (!date_error) { date_error = true; }
        }
        if (product.date_unlimited.isValid() && product.date_unlimited.isAfter(today)) {
            message += ' Unlimited availability from <strong>' + product.date_unlimited.format('D/M/YY') + '</strong>.<br />';
            if (!date_error) { date_error = true; }
        }
        if (product.date_to.isValid() && product.date_to.isAfter(today)) {
            message += ' Not available after <strong>' + product.date_to.format('D/M/YY') + '</strong>.<br />';
            if (!date_error) { date_error = true; }
        }
        if (date_error) {
            message += '<span style="color:grey">To get this product, change the delivery date in My Box.</span><br />';
        }
        return availErrorObj(message);
    }

    function availErrorObj(message) {
        return { success : false, message : message }
    }

    function maximumShouldChange(product) {
        return product.edit && product.maximum > 0 && product.edit_quantity > product.maximum;
    }

    function calculateInventory(type, product) {
        return type ==='current' ? product.inventory - product.ordered_current : product.inventory_next - product.ordered_next;
    }

    function displayInventory(quantity, product) {
        return product.fractions ? quantity/product.inventory_multiplier.toPrecision(1) : Math.floor(quantity/product.inventory_multiplier);
    }

    function addFamiliyQuantities(product) {
        const parent = product.base_product > 0 ? [parseInt(product.base_product)] : [],
            children = splitArray(product.children),
            siblings = splitArray(product.siblings, product.id),
            check = [...parent, ...children, ...siblings];
        let quantity = 0;
        doorstep.cart_products.forEach(function (product) {
            if (check.includes(product.id)) {
                quantity += (product.in_cart * product.inventory_multiplier);
            }
        });
        return quantity;
    }

    function splitArray(str, remove = 0) {
        return str !== null && str.length > 0 ? str.split('|').map(item => parseInt(item)).filter(item => item !== remove) : []
    }

    return {
        checkAvailability : checkAvailability
    }

})(jQuery);